import { Box, Skeleton, SxProps } from '@mui/material';
import { FC } from 'react';

export interface LabeledTextSkeletonProps {
  labelWidth: number;
  textWidth: number;
  sx?: SxProps;
}

export const LabeledTextSkeleton: FC<LabeledTextSkeletonProps> = (props) => {
  const { labelWidth, textWidth, sx } = props;

  return (
    <Box sx={{ marginTop: '10px', display: 'flex', flexDirection: 'column', ...sx }}>
      <Skeleton variant="text" sx={{ height: '15px', width: labelWidth + 'px' }} />
      <Skeleton variant="text" sx={{ height: '20px', width: textWidth + 'px' }} />
    </Box>
  );
};
